module.exports = __webpack_public_path__ + "img/audioImage@2x.2c1c8d6c.png";